import { LinkButton } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackGoToMyOffersClick } from './tracking';
import { useTrackingParams } from '../../hooks/useTrackingParams';
import { selectPageType } from '../../selectors';
import { EPageType } from '../../types/page/pageType';

export const GoToMyOffers: React.FC = () => {
  const pageType = useSelector(selectPageType);
  const isDesktop = useIsDesktop();
  const { siteType, dealType, cianSource } = useTrackingParams();

  const handler = () => {
    setTimeout(() =>
      trackGoToMyOffersClick({
        siteType,
        dealType,
        cianSource,
      }),
    );
  };

  if (pageType === EPageType.Tenant) {
    return null;
  }

  return (
    <LinkButton
      href="https://my.cian.ru/my-offers/"
      theme="fill_primary"
      size="L"
      fullWidth={!isDesktop}
      onClick={handler}
    >
      К моим объявлениям
    </LinkButton>
  );
};

GoToMyOffers.displayName = 'GoToMyOffers';
